const dns_table = {
	/* -------------------------------------------------------------------------- */
	/*                               ERROR MESSAGES                               */
	/* -------------------------------------------------------------------------- */
	error_messages: {
		ERR_A_1:
			"The IPv4 address entered is invalid. Verify that it is in the correct format (for example, 192.168.1.1) and that each segment is a number between 0 and 255.",
		ERR_AAAA_1:
			"The IPv6 address entered is invalid. Make sure it is in the correct format (for example, 2001:0db8:85a3:0000:0000:8a2e:0370:7334) and that each segment contains a hexadecimal number between 0000 and FFFF.",
		ERR_CNAME_1: "A CNAME record must not have @ as a label.",
		ERR_CNAME_2: "A CNAME record must have a valid domain name as its value and end in a dot (.)",
		ERR_CNAME_3: "Label already exists for other CNAME record.",
		ERR_LABEL_1: "The current label is not allowed.",
		ERR_MX_1: "An MX record must have a valid domain name as its value and end in a dot (.)",
		ERR_NONE_1: "It seems that the DNS data entered is incorrect.",
		ERR_NS_1: "An NS record may not have @ as a label.",
		ERR_NS_2: "An NS record must have a valid domain name as its value and end in a dot (.).",
		ERR_SRV_1: "Invalid label for SRV record: check that the label is entered correctly.",
		ERR_SRV_2: "Invalid value for SRV record: check that the value is entered correctly.",
		ERR_SRV_3: "Weight and port numbers must be between 0 and 65535",
	},
	/* -------------------------------------------------------------------------- */
	/*                                   HEADER                                   */
	/* -------------------------------------------------------------------------- */
	header: {
		label: {
			label: "Label",
			tooltip:
				"The domain or subdomain being designated. Use @ for your default domain (such as funexample.com). Do not enter the domain name in this field (or www, not www.funexample.com).",
		},
		priority: {
			label: "Priority",
		},
		ttl: {
			label: "TTL",
			tooltip:
				"Number of seconds the DNS servers wait for the record to be renewed. A shorter TTL means faster DNS updates in the future. Longer TTLs provide more tolerance and better performance.",
		},
		type: {
			label: "Type",
			tooltip:
				"The DNS type determines the requirements and behavior of the record. Each DNS type passes different information to the DNS server about the domain.",
		},
		value: {
			label: "Value",
			tooltip: "Record destination: value varies based on record type.",
		},
	},

	/* -------------------------------------------------------------------------- */
	/*                                  TABLE ROW                                 */
	/* -------------------------------------------------------------------------- */
	row: {
		buttons: {
			cancel: "Cancel",
			delete: "Delete",
			edit: "Edit",
			ok: "OK",
		},
		empty: "No DNS records found",
		label: {
			A: "e.g. @ or www",
			AAAA: "e.g. @ or www",
			CNAME: "e.g. api or blog",
			empty: "Empty",
			MX: "e.g. @ or mail",
			NS: "e.g. @ or mail",
			none: "e.g. @ or www",
			SRV: "_xmpp._tcp.example.com.",
			TLSA: "_443._tcp.example.com.",
			TXT: "e.g. @ or mail",
		},
		type: {
			placeholder: "Choose type",
		},
		value: {
			A: "XX.XX.XX.XX",
			AAAA: "XX:XX:XX:XX:XX:XX:XX:XX",
			CNAME: "example.com",
			MX: "smtp.example.com",
			NS: "ns1.example.com",
			none: "XX.XX.XX.XX",
			SRV: "0 0000 service.example.com.",
			TLSA: "0 0 0 d2abde240d7cd3ee6b4b28c54df034b97983a1d16e8a410e4561cb106618e971",
			TXT: "A textual value",
		},
	},
};

export default dns_table;
